import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class EmailEncuestaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'email-encuesta'].join('/');
  }

  public verificarDisponibilidad(id_email_encuesta) {
    return this.http
    .get([this.ApiUrl,'verificar-disponibilidad',id_email_encuesta].join('/'))
    .map(res => res.json());
  }

  public procesarEnvioEmail(model: any): Observable<any> {
    return this.http
      .post([this.ApiUrl, 'procesar-envio-email'].join('/'), {data: model})
      .map(res => res.json());
  }

  public generarEnlaces(model: any): Observable<any> {
    return this.http
      .post([this.ApiUrl, 'generar-enlaces'].join('/'), {data: model})
      .map(res => res.json());
  }

/*  public actualizarRadicado(model: any, id_orden): Observable<any> {
    return this.http
      .put([this.ApiUrl, id_orden,'radicado'].join('/'), {data: model})
      .map(res => res.json());    
  }*/


}



// WEBPACK FOOTER //
// ./src/app/services/email-encuesta/email-encuesta.service.ts